import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';
import { Link as RouterLink } from 'react-router-dom';
import { Drawer, ListItem, Toolbar } from '@mui/material';
import { RouterListItemLink } from './common';

interface ActiveElementProps {
  $isActive?: boolean;
  $isMainNav?: boolean;
}

export const StyledToolbar = styled(Toolbar)`
  align-items: stretch;
`;

export const Icon = styled(FontAwesomeIcon)`
  margin-right: 10px;
`;

export const ChevronIcon = styled(FontAwesomeIcon)`
  padding-left: 2px;
  margin-left: 4px;
`;

export const StyledPseudoLink = styled('span')<ActiveElementProps>`
  text-decoration: none;
  text-transform: capitalize;
  color: ${(props) => props.theme.palette.primary.contrastText};
  :hover {
    text-decoration: none;
    background-color: ${(props) =>
      props.$isActive
        ? props.theme.palette.secondary.main
        : props.theme.palette.primary.main};
  }
  border-radius: 0;
  background-color: ${(props) =>
    props.$isActive
      ? props.theme.palette.secondary.main
      : props.theme.palette.primary.main};
`;

export const StyledLink = styled(RouterLink)<ActiveElementProps>`
  text-decoration: none;
  text-transform: capitalize;
  color: ${(props) => props.theme.palette.primary.contrastText};
  :hover {
    text-decoration: none;
    background-color: ${(props) =>
      props.$isActive
        ? props.theme.palette.secondary.main
        : props.theme.palette.primary.main};
  }
  border-radius: 0;
  background-color: ${(props) =>
    props.$isActive
      ? props.theme.palette.secondary.main
      : props.theme.palette.primary.main};
`;

export const Grow = styled.div`
  flex-grow: 1;
`;

export const NestedList = styled.div`
  padding-left: 1rem;
`;

export const Primary = styled.span`
  flex-grow: 1;
  color: ${(props: any) => props.theme.palette.primary.main};
`;

export const StyledDrawer = styled(Drawer)`
  & > div {
    min-width: 20rem;
  }
`;

export const StyledRouterListItemLink = styled(
  RouterListItemLink
)<ActiveElementProps>`
  ${(props) =>
    props.$isMainNav &&
    `background-color:${props.theme.palette.primary.main}15;font-weight: bold;margin-top: 1rem;`}
  ${(props) => props.$isActive && `font-weight: bold;`}
    ${(props) =>
    props.$isActive &&
    `background-color: ${props.theme.palette.secondary.main}40;`}
`;

export const SideListItem = styled(ListItem)`
  font-weight: bold;
  margin-top: 1rem;
  background-color: ${(props) => `${props.theme.palette.primary.main}15;`};
`;
